// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"2df8b45e","703":"2621b611"}[chunkId] + ".chunk.js";
};